import { TypographyH1 } from "@/components/typography/H1";
import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";

const AccessDenied = () => {
  return (
    <div
      className="w-full h-screen flex flex-col items-center justify-center"
      data-testid="accessDenied"
    >
      <TypographyH1>Access denied</TypographyH1>
      <div className="text-sm text-slate-600 font-light mt-4 max-w-[64ch] text-center mb-24">
        You do not have permission to access this page. Only organization admins
        are allowed access. Contact your organization admin to request access.
      </div>

      <Link
        to="/organization/$organizationSlug/gallery"
        params={(prev) => ({ organizationSlug: prev.organizationSlug || "" })}
      >
        <Button variant="secondary">Go to App Gallery</Button>
      </Link>
    </div>
  );
};

export default AccessDenied;
